<template>
  <v-card
    :color="color"
    class="pl-2 d-flex elevation-4"
    dark
    @click="clickCard"
    :ref="idDom"
    height="100%"
  >
    <v-row no-gutters class="row pa-3">
      <v-col cols="3" class="row">
        <v-row no-gutters>
          <v-col cols="12"> #{{ index + 1 }} </v-col>
          <v-col cols="12">
            <icon class="ml-1" scale="2.1" :name="icon" />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="9" class="align-start text-left ml-2">
        <v-card-text class="font-weight-light px-0 pt-0 pb-0 ml-1">
          <div v-for="detail in details" :key="detail">{{ detail }}<br /></div>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'deployment-scenario-card',

  props: {
    color: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    scenarios: {
      type: Array,
      default: null
    },
    clickedCallback: {
      type: Function,
      default: function () {}
    }
  },

  methods: {
    clickCard() {
      this.clickedCallback(this.index)
    }
  },

  computed: {
    idDom() {
      return 'deployment-scenario-card' + this.index
    },

    icon() {
      // fontawesome icon
      if (this.index === 0) {
        return 'trophy'
      } else if (this.index === 1 || this.index === 2) {
        return 'medal'
      } else {
        return 'award'
      }
    },
    details() {
      return [
        this.scenarios[this.index].exploitationDate,
        this.scenarios[this.index].totalCostDisplay,
        this.scenarios[this.index].launchCountDisplay
      ]
    }
  }
}
</script>

<style scoped></style>
